/* eslint-disable react-hooks/exhaustive-deps */
import { filesAPI } from 'src/api/modules/files';
import notice from 'src/common/components/Notice';
import React, { useState, useEffect } from 'react';
import { columnsRecord2 } from './utils/list_data';
import BaseModal from 'src/common/components/Modal';
import FullTable from 'src/common/components/FullTable';
import { download } from 'src/pages/Files/UpaloadFileMinos';

const FileVersions = ({ open, setClose, dataSession, user, nameFileDetail }) => {
	const [fileHistory, setFileHistory] = useState([]);

	useEffect(() => {
		if (nameFileDetail !== undefined) getHistory();
	}, [nameFileDetail]);

	const getHistory = () => {
		setFileHistory([]);
		filesAPI
			.getFileHistory(
				'SESION',
				dataSession.id,
				dataSession.migrado,
				'H',
				nameFileDetail
			)
			.then((response) => {
				setFileHistory(response);
			})
			.catch((e) => {
				notice('Ocurrio un error al cargar el historial del archivo');
			});
	};

	const onDownload = (ruta) => {
		if (ruta.ruta !== undefined)
			download(
				ruta.ruta,
				ruta.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				undefined,
				'Archivo adicional, de la sesión ' + dataSession.numero_sesion
			);
	};

	return (
		<BaseModal
			open={open}
			onClose={setClose}
			onCancel={setClose}
			maxWidth="lg"
			cancelLabel="cerrar"
			mainText="Historial de Archivo"
		>
			<FullTable
				title={'Archivo: ' + nameFileDetail}
				items={fileHistory}
				columns={columnsRecord2(onDownload)}
			/>
		</BaseModal>
	);
};

export default FileVersions;
